// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/.pnpm/css-loader@7.1.5_webpack@5.111.1/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/.pnpm/css-loader@7.1.5_webpack@5.111.1/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
    /* ---------- LABELS ---------- */
    /* Primary */
    --ds-primary-button-color: var(--ds-color-grey-100);
    --ds-primary-button-disabled-color: var(--ds-color-grey-30);
    --ds-button-loading-icon-color: var(--ds-color-grey-10);
    /* Secondary */
    --ds-secondary-button-color: var(--ds-color-grey-10);
    --ds-secondary-button-disabled-color: var(--ds-color-grey-30);
    --ds-secondary-button-loading-icon-color: var(--ds-color-grey-10);
    /* Danger */
    --ds-danger-button-color: var(--ds-color-negative);
    --ds-danger-button-hover-color: var(--ds-color-negative);
    --ds-danger-button-disabled-color: var(--ds-color-grey-30);
    --ds-danger-button-loading-icon-color: var(--ds-color-grey-10);
    /* Ghost */
    --ds-ghost-button-color: var(--ds-color-grey-indigo-20);
    --ds-ghost-button-hover-color: var(--ds-color-grey-10);
    --ds-ghost-button-disabled-color: var(--ds-color-grey-30);
    --ds-ghost-button-loading-icon-color: var(--ds-color-grey-10);
    /* Ghost Danger */
    --ds-ghost-danger-button-color: var(--ds-color-negative);
    --ds-ghost-danger-button-hover-color: var(--ds-color-grey-10);
    --ds-ghost-danger-button-disabled-color: var(--ds-color-grey-30);
    --ds-ghost-danger-button-loading-icon-color: var(--ds-color-grey-10);
    /* Link */
    --ds-link-button-color: var(--ds-color-grey-10);
    --ds-link-button-hover-color: var(--ds-color-neon-0);
    --ds-link-button-disabled-color: var(--ds-color-grey-30);
    --ds-link-button-loading-icon-color: var(--ds-color-grey-10);
    /* Wrapper - used directly in the application */
    --ds-wrapper-button-hover-color: var(--ds-color-grey-indigo-30);
    /* ---------- BACKGROUNDS ---------- */
    /* Primary */
    --ds-primary-button-bg-color: var(--ds-color-grey-indigo-10);
    --ds-primary-button-hover-bg-color: var(--ds-color-neon-0);
    --ds-primary-button-disabled-bg-color: var(--ds-color-grey-50);
    --ds-primary-button-loading-bg-color: var(--ds-color-grey-50);
    /* Secondary */
    --ds-secondary-button-bg-color: none;
    --ds-secondary-button-hover-bg-color: var(--ds-color-grey-indigo-50);
    --ds-secondary-button-disabled-bg-color: var(--ds-color-grey-50);
    --ds-secondary-button-loading-bg-color: var(--ds-color-grey-50);
    /* Danger */
    --ds-danger-button-bg-color: var(--ds-color-negative-bg);
    --ds-danger-button-disabled-bg-color: var(--ds-color-grey-50);
    --ds-danger-button-hover-bg-color: var(--ds-color-negative-bg);
    --ds-danger-button-loading-bg-color: var(--ds-color-grey-50);
    /* Ghost */
    --ds-ghost-button-bg-color: none;
    /* Ghost Danger */
    --ds-ghost-danger-button-bg-color: none;
    /* Link */
    --ds-link-button-bg-color: none;
    /* ---------- BORDERS ---------- */
    /* Secondary */
    --ds-secondary-button-border-color: var(--ds-color-grey-10);
    /* Danger */
    --ds-danger-button-hover-border-color: var(--ds-color-negative);
    /* Secondary/Danger button box shadow is used instead of border to not alter button size */
    /* Box Shadows */
    /* Secondary */
    --ds-secondary-button-box-shadow: 0 0 0 1px
        var(--ds-secondary-button-border-color) inset;
    /* Danger */
    --ds-danger-button-hover-box-shadow: 0 0 0 1px
        var(--ds-danger-button-hover-border-color) inset;
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
